export default __webpack_public_path__ + "static/media/BLR16.9a8dbabe.jpg";